import Vue from 'vue';
import Vuex from 'vuex';
import Global from '@/global-view/vuex';
import Users from '@/global-view/admin/sub-users/vuex';
import Websites from '@/global-view/admin/websites/vuex';
import Account from '@/global-view/admin/account/vuex';
import Notifications from '@/global-view/notifications/vuex';
import TopControlBar from '@editor/page/top-control-bar/vuex';
import AddPage from '@editor/page/top-control-bar/add-page/vuex';
import AddTemplate from '@editor/page/top-control-bar/add-template/vuex';
import SavePage from '@editor/page/top-control-bar/creator-options/vuex';
import PageSettings from '@editor/page/top-control-bar/page-settings/vuex';
import OnlineStore from '@editor/page/top-control-bar/dynamic-data/store/orders/vuex';
import DynamicData from '@editor/page/top-control-bar/dynamic-data/vuex';
import SiteMap from '@editor/page/top-control-bar/global-options/site-map/vuex';
import GlobalOptions from '@editor/page/top-control-bar/global-options/vuex';
import PageEditor from '@editor/page/vuex';
import DropletContainer from '@editor/page/droplets-tab/vuex';
import DropletBubbleOptions from '@editor/droplets/_bubble-options/vuex';
import SaveAlert from '@editor/page/save-alert/vuex';
import EditorLoader from '@editor/page/page-loader/vuex';
import StyleSidebar from '@editor/page/style-sidebar/vuex';
import Tickets from '@/global-view/admin/support/tickets/vuex';
import Storm from '@storm/store/vuex';
// droplets list
import Section from '@editor/droplets/section/vuex';
import MainNav from '@editor/droplets/navigation/vuex';
import TextGeneral from '@editor/droplets/text-general/vuex';
import Header from '@editor/droplets/header/vuex';
import Button from '@editor/droplets/button/vuex';
import AudioPlayer from '@editor/droplets/audio-player/vuex';
import VideoPlayer from '@editor/droplets/video-player/vuex';
import CountDown from '@editor/droplets/countdown/vuex';
import GoogleMap from '@editor/droplets/google-map/vuex';
import SocialMedia from '@editor/droplets/social-media/vuex';
import Form from '@editor/droplets/form/vuex';
import Columns from '@editor/droplets/columns/vuex';
import Accordion from '@editor/droplets/accordion/vuex';
import Tabs from '@editor/droplets/tabs/vuex';
import FooterNav from '@editor/droplets/footer-nav/vuex';
import Table from '@editor/droplets/table/vuex';
import CardsTall from '@editor/droplets/cards-tall/vuex';
import CardsGeneral from '@editor/droplets/cards-general/vuex';
import CardsWide from '@editor/droplets/cards-wide/vuex';
import CardsEvent from '@editor/droplets/cards-event/vuex';
import CardsStep from '@editor/droplets/cards-step/vuex';
import CodeGeneral from '@editor/droplets/code-general/vuex';
import ContentSlider from '@editor/droplets/content-slider/vuex';
import Carousel from '@editor/droplets/carousel/vuex';
import ImageGallery from '@editor/droplets/image-gallery/vuex';
import ImageGeneral from '@editor/droplets/image-general/vuex';
import YouTubeVideo from '@editor/droplets/youtube-video/vuex';

Vue.use(Vuex);

const modules = {
  Global,
  Users,
  Account,
  Notifications,
  Websites,
  DropletBubbleOptions,
  TopControlBar,
  StyleSidebar,
  Tickets,
  AddPage,
  AddTemplate,
  SavePage,
  PageSettings,
  OnlineStore,
  DynamicData,
  SiteMap,
  GlobalOptions,
  PageEditor,
  DropletContainer,
  SaveAlert,
  EditorLoader,
  Section,
  MainNav,
  TextGeneral,
  Header,
  Button,
  AudioPlayer,
  VideoPlayer,
  CountDown,
  GoogleMap,
  SocialMedia,
  Form,
  Columns,
  Accordion,
  Tabs,
  FooterNav,
  Table,
  CardsTall,
  CardsGeneral,
  CardsWide,
  CardsEvent,
  CardsStep,
  CodeGeneral,
  ContentSlider,
  Carousel,
  ImageGallery,
  ImageGeneral,
  YouTubeVideo,
};

if (process.env.ADMIN === 'storm') {
  modules.Storm = Storm;
}

const store = new Vuex.Store({
  modules,
  strict: true,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js